import { createMarkupAdjustableSelector } from 'utils/markup';

import { getBodyData } from '../../selectors';

const getDetailsPageData = getBodyData;

export const getProductOutOfStockDetails = (state) =>
  getDetailsPageData(state).outOfStockDetails || {};

/** form out of stock in card */
export const getOutOfStockFormState = (state) => getProductOutOfStockDetails(state).isOpened;
export const getOutOfStockPopupHeader = (state) => getProductOutOfStockDetails(state).header;
export const getOutOfStockAgreementDataUrl = (state) =>
  getProductOutOfStockDetails(state).agreementDataUrl;
export const getOutOfStockAgreementState = (state, id) =>
  !!getProductOutOfStockDetails(state).agreementUncheckedState[id];
export const getOutOfStockStoreMessage = (state) => getProductOutOfStockDetails(state).message;
export const getOutOfStockEmojiPath = (state) => getProductOutOfStockDetails(state).emoji;
export const getOutOfStockClassName = (state) => getProductOutOfStockDetails(state).className;

export const getOutOfStockPopupState = (state) => getProductOutOfStockDetails(state).popupState;
export const getOutOfStockPopupDescription = (state) =>
  getProductOutOfStockDetails(state).popupDescription;
export const getOutOfStockView = (state) => getProductOutOfStockDetails(state).stockView;
export const getOutOfStockErrorFetchedText = (state) =>
  getProductOutOfStockDetails(state).fetchedText;

/** backend data texts */
export const getCatalogOutOfStockTexts = (state) => getDetailsPageData(state).outOfStock || {};

export const getOutOfStockSuccessText = (state) =>
  getCatalogOutOfStockTexts(state).successText || '';
export const getOutOfStockErrorText = (state) => getCatalogOutOfStockTexts(state).errorText || '';
export const getOutOfStockAgreementDataText = (state) =>
  getCatalogOutOfStockTexts(state).agreementDataText || '';

export const getOutOfStockDefaultMessage = (state) =>
  getDetailsPageData(state).outOfStockMessageTemplate || '';
export const getOutOfStockMessageTemplate = (state) =>
  getOutOfStockStoreMessage(state) || getOutOfStockDefaultMessage(state);
export const getOutOfStockMessage = createMarkupAdjustableSelector(getOutOfStockMessageTemplate);
